export function createUniqueIdGenerator(prefix: string = '') {
  let i = 0;

  return () => `${prefix}${++i}`;
}
